import { ArrowBack, ArrowForward } from "@mui/icons-material";
import { Button, Divider, Paper, Stack } from "@mui/material";
import {
  CustomImage,
  CustomProgressBar,
  CustomText,
  PaperButton,
} from "components";
import { addressDetailInfo } from "models/third/addressRight";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { openLoading } from "store/reducers/tools";
import { formatArray, notify, serverPost } from "utility";
import { DispatchHeader } from "../DispatchHeader";

import Layout from "layouts";
import { getLabel } from "models/third/freightways";
import { useLocation } from "react-router-dom";

export function Orderoverview() {
  const dispatch = useDispatch();
  const location = useLocation();
  const { boxes = [] } = useSelector((state) => state?.app ?? {});
  const [selIndex, setSelIndex] = useState(location?.state ?? 0);
  const [selBox, setSelBox] = useState({});
  const [file, setFile] = useState("");

  const meals = useMemo(() => selBox?.meals ?? {}, [selBox]);

  const handleCreateTicketNumber = async () => {
    try {
      openLoading(true);
      const addressId = selBox?.address?.id ?? "";
      // const freightwaysAuth = await authFreightways();
      const addressInfo = await addressDetailInfo(addressId);
      serverPost({
        url: "freightway/consignment",
        data: {
          orderId: selBox?.id,
          userId: selBox?.userId,
          address: addressInfo,
          // token: freightwaysAuth?.data?.access_token,
        },
        onFinish: async (res, err) => {
          if (res === false) {
            notify({
              message:
                err?.error?.status === 409
                  ? "The consignment with consignmentId already exists"
                  : "Tracking info is invalid.",
              variant: "warning",
            });
            openLoading(false);
            return;
          }
          const fileURL = await getLabel({
            trackingInfo: res?.slot?.trackingInfo ?? {},
            postCode: selBox?.address?.postCode,
            // access_token: freightwaysAuth?.data?.access_token,
          });
          setFile(fileURL);
          dispatch({
            type: "SET_APP",
            payload: {
              boxes: [
                ...boxes.slice(0, selIndex),
                {
                  ...(boxes?.[selIndex] ?? {}),
                  trackingInfo: res?.slot?.trackingInfo ?? {},
                },
                ...boxes.slice(selIndex + 1),
              ],
            },
          });
          notify({ message: "Successfully created.", variant: "success" });
        },
      });
    } catch (err) {
      openLoading(false);
      notify({
        message: "Tracking info is invalid.",
        variant: "warning",
      });
      console.log(err, "err");
    }
  };

  useEffect(() => {
    setSelBox((s = {}) => ({
      ...(boxes?.[selIndex] ?? {}),
    }));
    //eslint-disable-next-line
  }, [boxes, selIndex]);

  useEffect(() => {
    if (Boolean(file)) {
      setTimeout(() => {
        window.frames["printffull"].focus();
        window.frames["printffull"].print();
        openLoading(false);
      }, 1000);
    }
    // eslint-disable-next-line
  }, [file]);

  return (
    <Layout sidebar={false} noHeader={true}>
      <div>
        <DispatchHeader backButton={false} backButtonIcon={true} />
        <div className="py-2">
          <Paper className="p-4" elevation={2}>
            <Stack
              direction="row"
              flexWrap={true}
              spacing={4}
              divider={<Divider orientation="vertical" flexItem />}
            >
              <div>
                <CustomText className="p-1" variant="body2" color="secondary">
                  Order Number
                </CustomText>
                <CustomText className="p-1" variant="h5" color="secondary" bold>
                  {`#${selBox?.id}`}
                </CustomText>
              </div>
              <div>
                <CustomText className="p-1" variant="body2" color="secondary">
                  Name
                </CustomText>
                <CustomText className="p-1" variant="h5" color="secondary" bold>
                  {`${selBox?.firstName} ${selBox?.lastName}`}
                </CustomText>
              </div>
              <div>
                <CustomText className="p-1" variant="body2" color="secondary">
                  Address:
                </CustomText>
                <CustomText className="p-1" variant="h5" color="secondary" bold>
                  {selBox?.address?.label ?? ""}
                </CustomText>
              </div>
            </Stack>
          </Paper>
        </div>
        <div className="flex py-2">
          <Paper className="flex-1 mr-4" elevation={2}>
            <CustomText className="px-4 py-6 text-xl" variant="body2">
              <span className="text-xl font-semibold">Delivery Notes:</span>
              &nbsp; {selBox?.other?.box_note ?? ""}
            </CustomText>
          </Paper>
          <PaperButton
            elevation={2}
            background={
              Boolean(selBox?.trackingInfo?.consignmentId)
                ? "bg-success"
                : "bg-light-yellow"
            }
          >
            <span
              className={`p-6 text-2xl ${
                Boolean(selBox?.trackingInfo?.consignmentId) ? "text-white" : ""
              }`}
            >
              Status:{" "}
              {Boolean(selBox?.trackingInfo?.consignmentId)
                ? "Fulfilled"
                : "Unfulfilled"}
            </span>
          </PaperButton>
        </div>
        <div className="py-4">
          <Paper className="py-4" elevation={2}>
            <CustomText className="px-4 pb-4 text-2xl" variant="h6" bold>
              Order Contains:
            </CustomText>
            {formatArray(meals).map((item, index) => {
              return (
                <div
                  className={`${
                    !Boolean(index % 2) ? "bg-whiteSmoke" : "bg-white"
                  } flex w-full p-2 flex-wrap items-center`}
                  key={index}
                >
                  <div className="sm:w-2/5 flex items-center">
                    <CustomText
                      className="pl-8 text-2xl"
                      bold={600}
                    >{`${item?.count} x`}</CustomText>
                    <CustomText className="pl-8 text-2xl" bold>
                      {item?.meal?.name?.toUpperCase() ?? ""}
                    </CustomText>
                  </div>
                  {Array.from({ length: item?.count }, (_, i) => (
                    <CustomImage
                      className="w-24 px-2"
                      src={item?.meal?.image}
                      key={i}
                    />
                  ))}
                </div>
              );
            })}
          </Paper>
        </div>
        <div className="flex items-center py-2">
          <div className="flex-1">
            <CustomProgressBar
              variant="determinate"
              height={12}
              value={
                boxes?.length === 0 ? 0 : ((selIndex + 1) / boxes?.length) * 100
              }
            />
          </div>
          <CustomText className="p-2" variant="body2" bold>
            {selIndex + 1}/{boxes?.length}
          </CustomText>
        </div>
        <div className="flex justify-between w-full pt-2 pb-5">
          <Button
            size="large"
            color="inherit"
            variant="contained"
            startIcon={<ArrowBack />}
            disabled={selIndex === 0}
            onClick={() => setSelIndex((s) => s - 1)}
          >
            <span className="text-2xl py-4">
              Previous ({selIndex === 0 ? selIndex : selIndex - 1}&nbsp;/&nbsp;
              {boxes.length})
            </span>
          </Button>
          <Button
            size="large"
            variant="contained"
            className="flex-1 mx-2"
            color="primary"
            disabled={Boolean(selBox?.trackingInfo?.consignmentId)}
            onClick={handleCreateTicketNumber}
          >
            <span className="text-2xl py-4">
              {Boolean(selBox?.trackingInfo?.consignmentId)
                ? "FULFILL"
                : "FULFILL & PRINT TICKET"}
            </span>
          </Button>
          <Button
            size="large"
            color="inherit"
            variant="contained"
            endIcon={<ArrowForward />}
            disabled={selIndex + 1 === boxes?.length}
            onClick={() => setSelIndex((s) => s + 1)}
          >
            <span className="text-2xl py-4">
              Next ({selIndex + 1}&nbsp;/&nbsp;{boxes.length})
            </span>
          </Button>
        </div>
        <iframe
          title="delivery ticket label"
          style={{ display: "none" }}
          id="printffull"
          src={file}
          name="printffull"
        ></iframe>
      </div>
    </Layout>
  );
}
